import Vue from 'vue'
import { Tooltip } from 'ant-design-vue'
import _ from 'lodash'
import {
  convertDate,
  formatValue,
  timeConvert,
  formatPercentage,
} from '@/services/convert'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <div :class="{ 'cell-ellipsis': ellipsis }">
        <a-tooltip placement="right" :title="title" v-if="!fieldName || fieldName!=='timeSpent'"> {{value}} </a-tooltip>
        <a-popover title="Time Spent" v-if="fieldName ==='timeSpent'" placement="left">
          <template slot="content">
            <div v-for="time in title">
              {{time.name}} : {{convertTime(time.timeSpent)}}
            </div>
          </template>
          {{value}}
        </a-popover>
      </div>
      `,
  data: function() {
    return {
      value: undefined,
      title: undefined,
      // LPA-9: single-line "…" overflow; autoHeight columns keep wrapping
      ellipsis: true,
      fieldName: '',
    }
  },
  beforeMount() {
    this.ellipsis = !_.get(this.params, 'colDef.autoHeight', false)
    const name = this.params.colDef['cellRendererParams']
      ? this.params.colDef['cellRendererParams'].name
      : ''
    this.fieldName = name
    if (this.params.colDef.field === 'quantity') {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      const value = _.get(this.params, 'value', null)
      if (value) {
        this.value = new Intl.NumberFormat(settings.currency.currencyFormate, {
          currency: settings.currency.currency,
        }).format(value)
        this.title = this.value
      } else {
        this.value = _.get(this.params, 'value', null)
        this.title = _.get(this.params, 'value', null)
      }
    } else {
      switch (name) {
        case 'id':
          this.value = this.params.data.id ? this.params.data.id : ''
          this.title = this.params.data.id ? this.params.data.id : ''
          break
        case 'assetNumber':
          this.value = this.params.data.assetNumber
          this.title = this.value =
            this.params.data.assetNumber && this.params.data.assetDescription
              ? this.params.data.assetNumber +
                ' - ' +
                this.params.data.assetDescription
              : this.params.data.assetNumber
          break
        case 'assetDescription':
          this.value =
            this.params.data.assetNumber && this.params.data.assetDescription
              ? this.params.data.assetNumber +
                ' - ' +
                this.params.data.assetDescription
              : this.params.data.assetNumber
          this.title = this.value =
            this.params.data.assetNumber && this.params.data.assetDescription
              ? this.params.data.assetNumber +
                ' - ' +
                this.params.data.assetDescription
              : this.params.data.assetNumber
          break
        case 'contract':
          this.value =
            this.params.data.contract || this.params.data.contract === 0
              ? parseFloat(this.params.data.contract)
              : null
          this.title =
            (this.params.data.contract || this.params.data.contract === 0) &&
            this.params.data.contractName
              ? this.params.data.contract +
                ' - ' +
                this.params.data.contractName
              : this.params.data.contract
          break
        case 'contractName':
          this.value =
            (this.params.data.contract || this.params.data.contract === 0) &&
            this.params.data.contractName
              ? parseFloat(this.params.data.contract) +
                ' - ' +
                this.params.data.contractName
              : this.params.data.contract
          this.title =
            (this.params.data.contract || this.params.data.contract === 0) &&
            this.params.data.contractName
              ? parseFloat(this.params.data.contract) +
                ' - ' +
                this.params.data.contractName
              : this.params.data.contract
          break
        case 'categoryCode':
          this.value = this.params.data.categoryCode
          this.title =
            this.params.data.categoryCode &&
            this.params.data.categoryCodeDescription
              ? this.params.data.categoryCode +
                ' - ' +
                this.params.data.categoryCodeDescription
              : this.params.data.categoryCode
          break
        case 'categoryCodeDescription':
          this.value =
            this.params.data.categoryCode &&
            this.params.data.categoryCodeDescription
              ? this.params.data.categoryCode +
                ' - ' +
                this.params.data.categoryCodeDescription
              : this.params.data.categoryCode
          this.title =
            this.params.data.categoryCode &&
            this.params.data.categoryCodeDescription
              ? this.params.data.categoryCode +
                ' - ' +
                this.params.data.categoryCodeDescription
              : this.params.data.categoryCode
          break
        case 'assetClass':
          this.value = this.params.data.assetClass
          this.title =
            this.params.data.life && this.params.data.assetClass
              ? this.params.data.assetClass + '-' + this.params.data.life
              : this.params.data.assetClass
          break
        case 'life':
          this.value =
            this.params.data.life !== null &&
            this.params.data.life !== undefined &&
            this.params.data.assetClass
              ? this.params.data.assetClass + '-' + this.params.data.life
              : this.params.data.assetClass
          this.title =
            this.params.data.life !== null &&
            this.params.data.life !== undefined &&
            this.params.data.assetClass
              ? this.params.data.assetClass + '-' + this.params.data.life
              : this.params.data.assetClass
          break
        case 'multiplier':
          this.value = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 3).toFixed(3)
            : 1
          this.title = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 3).toFixed(3)
            : 1
          break
        case 'varianceFactor':
          this.value = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 2).toFixed(2)
            : 1
          this.title = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 2).toFixed(2)
            : 1
          break
        case 'calculation':
          this.value = _.get(this.params, 'value', null)
          this.title = _.get(this.params.data, 'formula', null)
          break
        case 'structureProfile':
          if (this.params.data.linkMethod && this.params.data.linkedAssetId) {
            this.value = _.get(this.params, 'value', null)
            this.title = `You can not change the structure profile as asset is linked with ${this.params.data.link}. First unlink the asset then change the structure profile.`
          } else if (this.params.data.linkMethod) {
            this.value = _.get(this.params, 'value', null)
            this.title =
              'You can not change the structure profile as asset is linked with other assets. First unlink all the assets then change the structure profile.'
          } else {
            this.value = _.get(this.params, 'value', null)
            this.title = _.get(this.params, 'value', null)
          }
          break
        case 'createdDate':
        case 'updatedDate':
          this.value = convertDate(this.params.value, true)
          this.title = convertDate(this.params.value, true)
          break
        case 'constructionQualityFactor':
          this.value = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 2).toFixed(2)
            : this.params.value
          this.title = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 2).toFixed(2)
            : this.params.value
          break
        case 'conditionFactor':
          this.value = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 2).toFixed(2)
            : this.params.value
          this.title = _.get(this.params, 'value', null)
            ? formatValue(this.params.value, 2).toFixed(2)
            : this.params.value
          break
        case 'percentComplete':
          this.value = this.params.value
            ? `${formatValue(this.params.value, 2).toFixed(2)}%`
            : '0.00%'
          this.title = this.params.value
            ? `${formatValue(this.params.value, 2).toFixed(2)}%`
            : '0.00%'
          break
        case 'estimateMethod':
          this.value =
            this.params.value === 1
              ? 'Variance'
              : this.params.value === 2
                ? 'Residual'
                : ''
          this.title =
            this.params.value === 1
              ? 'Variance'
              : this.params.value === 2
                ? 'Residual'
                : ''
          break
        case 'takeoffSource':
          if (this.params.data && this.params.data.costType === 'Estimate') {
            this.value = 'M-Manual'
            this.title = 'M-Manual'
            this.displayCostSource()
          }
          break
        case 'newContract':
          if (this.params.value || this.params.value === 0) {
            const contract = this.params.dropdownData.contract.find(
              i =>
                i.value &&
                (i.value.split(' - ')[0] === String(this.params.value) ||
                  i.value.split(' - ')[0] ===
                    String(formatValue(this.params.value, 2).toFixed(2))),
            )
            this.value = contract ? contract.value.split(' - ')[0] : undefined
            this.title = contract ? contract.value.split(' - ')[0] : undefined
          }
          break
        case 'timeSpent':
          this.value = this.params.value ? timeConvert(this.params.value) : ''
          if (this.params.data.projectTimeLogs) {
            this.title = this.params.data.projectTimeLogs
          }
          break
        case 'depreciation %':
          this.value =
            this.params.value || this.params.value === 0
              ? `${formatPercentage(this.params.value)}%`
              : this.params.value
          this.title = this.value
          break
        default:
          this.value = _.get(this.params, 'value', null)
          this.title = _.get(this.params, 'value', null)
          break
      }
    }
  },

  methods: {
    displayCostSource() {
      if (this.params.data.templateId) {
        this.value = `T-${this.params.data.templateName}`
        this.title = `T-${this.params.data.templateName}`
      } else if (this.params.data.tenantBankId) {
        if (this.params.data.interiorGroupId) {
          this.value = `TB-${this.params.data.tenant}-${this.params.data.interiorGroup}`
          this.title = `TB-${this.params.data.tenant}-${this.params.data.interiorGroup}`
        } else {
          this.value = `TB-${this.params.data.tenant}`
          this.title = `TB-${this.params.data.tenant}`
        }
      } else if (this.params.data.interiorGroupId) {
        this.value = `G-${this.params.data.interiorGroup}`
        this.title = `G-${this.params.data.interiorGroup}`
      }
    },

    convertTime(timeSpent) {
      return timeConvert(timeSpent)
    },
  },
})
